import { publicRequest } from "../../../requestMeth";
import { 
  checkFailure,
  checkStart,
  checkSuccess,
  ForgotPassFailure, 
  ForgotPassStart, 
  ForgotPassSuccess,
  ResetConfirmFailure,
  ResetConfirmStart,
  ResetConfirmSuccess
} from "../../reducers/forgotPass/forgot_passRedux";

export const forgotPassword = async (dispatch, email) => {
  dispatch(ForgotPassStart());
  try {
    const res = await publicRequest.post("/password/forgot", { email });
    dispatch(ForgotPassSuccess(res.data)); 
  } catch (error) {
      const status = error?.response?.status ?? null;
       const message = error?.response?.data?.error || error?.message || "Request failed";
       dispatch(ForgotPassFailure({ status, message }));
  }
};

export const checkResetToken = async (dispatch, token) => {
  try {
    dispatch(checkStart());
    await publicRequest.get("/password/check", { params: { token } });
    dispatch(checkSuccess());
    return true;
  } catch (err) {
    const msg = err?.response?.data?.error || "";
    const reason = /already used/i.test(msg)
      ? "used"
      : /expired/i.test(msg)
      ? "expired"
      : "invalid";
    dispatch(checkFailure({ reason, message: msg }));
    return false;
  }
};

export const confirmResetPassword = async (dispatch, { token, pass }) => {
  dispatch(ResetConfirmStart());
  try {
    const res = await publicRequest.post("/password/confirm", { token, pass });
    dispatch(ResetConfirmSuccess(res.data));
    return true;
  } catch (error) {
    const payload = error?.response?.data || { message: "Request failed" };
    dispatch(ResetConfirmFailure(payload));
    return false;
  }
};